import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientsComponent } from './UI/pages/clients/clients.component';
import { SystemModulesComponent } from './UI/pages/system-modules/system-modules.component';
import { GroupsComponent } from './UI/pages/groups/groups.component';
import { RolesComponent } from './UI/pages/roles/roles.component';
import { ForgotPasswordComponent, LoginComponent, RegistrationComponent } from '@mangosoft/mango-login';
import { LoginGuardGuard } from './Infrastructure/guards/login-guard.guard';
import { ModulesGuard } from './Infrastructure/guards/modules-guard.guard';
import { UsersComponent } from './UI/pages/users/users.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'users',
		pathMatch: 'full',
	},
	{
		path: 'login',
		component: LoginComponent,
		canActivate: [LoginGuardGuard],
	},
	{
		path: 'forgot-password',
		component: ForgotPasswordComponent,
		canActivate: [LoginGuardGuard],
	},
	{
		path: 'system-modules',
		component: SystemModulesComponent,
		canActivate: [ModulesGuard],
	},
	{
		path: 'system-modules/:id',
		component: SystemModulesComponent,
		canActivate: [ModulesGuard],
	},
	{
		path: 'clients',
		component: ClientsComponent,
		canActivate: [ModulesGuard],
	},
	{
		path: 'roles',
		component: RolesComponent,
		canActivate: [ModulesGuard],
	},
	{
		path: 'groups',
		component: GroupsComponent,
		canActivate: [ModulesGuard],
	},
	{
		path: 'users',
		component: UsersComponent,
		canActivate: [ModulesGuard],
	},
];
@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
